import { AbstractFormatPropertyAlert } from "../../editableFormat/alerts/AbstractFormatPropertyAlert";

export class FormatPropertyQuestionnaireNameAlert extends AbstractFormatPropertyAlert {
  constructor(propertyKind: string, isError: boolean) {
    super(propertyKind, isError);
  }

  get description(): string {
    return "プロジェクトコード(7byte) + 識別コード・セット番号(6byte) + 一意番号(2byte)で入力されていません。";
  }
}
